import { addDays, addMinutes, differenceInMinutes } from 'date-fns';
import { TimeTracking } from '../models/timeTracking';
import { getFromToPauseValues } from './getTimeTrackingFromToPauseValues';

export function formatTimeNumber(time: number): string {
  if ((!time && time != 0) || time < 0) {
    return 'Invalid';
  }
  let timeStr = time.toString();
  if (timeStr.length < 1) {
    return 'Invalid';
  }
  let minutes = timeStr.substr(timeStr.length - 2, 2);
  if (Number(minutes) > 59) {
    return 'Invalid';
  }
  if (minutes.length == 1) {
    minutes = '0' + minutes;
  }
  if (minutes.length == 0) {
    minutes = '00';
  }
  let hours = timeStr.substr(0, timeStr.length - 2);
  if (Number(hours) > 23) {
    return 'Invalid';
  }
  if (hours.length == 1) {
    hours = '0' + hours;
  }
  if (hours.length == 0) {
    hours = '00';
  }
  return hours + ':' + minutes;
}
export const militaryTimeToMinutes = (time: string): number => {
  if (time === '0') return 0;
  const hours = time.slice(0, time.length - 2) || '0';
  const minutes = time.slice(time.length - 2, time.length) || '0';
  return parseInt(hours) * 60 + parseInt(minutes);
};

export const minutesToMilitaryTime = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  return hours * 100 + minutes;
};
export function getTimeTrackingTotal(
  timeTrackings: TimeTracking[],
  date: string,
): number {
  return getTotalOfTrackedTime(
    timeTrackings.map((timeTracking) => getFromToPauseValues(timeTracking)),
    date,
  );
}

export function getTotalOfTrackedTime(
  timeTrackings: { from: number; to: number; pause?: number }[],
  date: string,
): number {
  let total = 0;

  timeTrackings.forEach((timeTracking) => {
    let fromMinutes = militaryTimeToMinutes(timeTracking.from.toString());
    let toMinutes = militaryTimeToMinutes(timeTracking.to.toString());
    let fromDate = addMinutes(new Date(date), fromMinutes);
    let toDate = addMinutes(new Date(date), toMinutes);
    if (timeTracking.to < timeTracking.from) {
      toDate = addDays(toDate, 1);
    }
    if (!timeTracking.pause) {
      timeTracking.pause = 0;
    }
    let pauseTime = militaryTimeToMinutes(timeTracking.pause.toString());
    total += differenceInMinutes(toDate, fromDate) - pauseTime;
  });
  return minutesToMilitaryTime(total);
}

export const minutesToHourAndMinutes = (time: number) => {
  if (!time) return `0h 0m`;
  const timeString = time?.toString();
  const hours = timeString.slice(0, timeString.length - 2);
  const minutes = timeString.slice(timeString.length - 2, timeString.length);
  return `${hours ? hours : '0'}h ${minutes}m`;
};

export const militaryTimeToHourAndMinutes = (
  time: number,
): { hours: number; minutes: number } => {
  if (!time) return { hours: 0, minutes: 0 };
  const timeString = time?.toString();
  const hours = timeString.slice(0, timeString.length - 2);
  const minutes = timeString.slice(timeString.length - 2, timeString.length);
  return { hours: parseInt(hours) || 0, minutes: parseInt(minutes) || 0 };
};

export const militaryTimeToHourAndMinuteStrings = (
  time: number,
): { hours: string; minutes: string } => {
  if (!time) return { hours: '00', minutes: '00' };
  const timeString = time?.toString();
  let hours = timeString.slice(0, timeString.length - 2);
  if (hours.length === 1) {
    hours = '0' + hours;
  } else if (!hours) {
    hours = '00';
  }
  const minutes = timeString.slice(timeString.length - 2, timeString.length);
  return { hours: hours, minutes: minutes };
};
